<template>
	<Teleport to="body">
		<div class="modal-overlay" @click="emit('close')">
			<div class="modal-content" @click.stop>
				<div class="modal-header">
					<h3>{{ t("opportunities-table.edit-modal.title") }} — {{ opportunity.address }}</h3>
					<button type="button" class="close-btn" :title="t('callToActions.close')" @click="emit('close')">
						<AppIcon :name="IconName.CloseSmall" :size="16" :stroke-width="1.3" />
					</button>
				</div>

				<div class="modal-body">
					<OpportunityEditFields :key="opportunity.id" :opportunity="opportunity" />
				</div>
			</div>
		</div>
	</Teleport>
</template>

<script setup lang="ts">
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"
import type { Opportunity } from "@/model/DataModel"
import { useI18n } from "vue-i18n"
import OpportunityEditFields from "./OpportunityEditFields.vue"

defineProps<{
	opportunity: Opportunity
}>()

const emit = defineEmits<{
	(e: "close"): void
}>()

const { t } = useI18n()
</script>

<style scoped>
.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur(4px);
	z-index: 1000;
}

.modal-content {
	width: 90%;
	max-width: 1160px;
	max-height: 85vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background: var(--neutral-0);
	border-radius: var(--border-radius-lg);
	box-shadow: var(--shadow-xl);
}

.modal-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--spacing-sm);
	padding: var(--spacing-lg);
	border-bottom: var(--border-width-thin) solid var(--neutral-200);

	h3 {
		margin: 0;
		color: var(--neutral-900);
		font-family: var(--font-family-primary);
		font-size: var(--font-size-large);
		font-weight: var(--font-weight-semibold);
	}

	.close-btn {
		width: var(--size-icon-xl);
		height: var(--size-icon-xl);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		border: none;
		background: none;
		color: var(--neutral-600);
		cursor: pointer;
		transition: color 0.2s ease;

		&:hover {
			color: var(--neutral-900);
		}
	}
}

.modal-body {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-lg);
	padding: var(--spacing-lg);
	overflow-y: auto;
}
</style>
